/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import { useNavigate } from 'react-router-dom';
import { Notification } from '@types';
import { Button } from 'react-daisyui';
import { formatDate } from '@/utils';

interface Props {
  notifications: Notification[];
  dismissNotification: (notificationId: number) => Promise<void>;
}

function Notifications({ notifications, dismissNotification }: Props) {
  const navigate = useNavigate();

  const onClickNotification = (notification: Notification) => {
    navigate(`${notification.url}`);
    dismissNotification(Number(notification?.id))
      .then(() => {})
      .catch(() => {
        console.error('Error dismissing notification');
      });
  };

  return (
    <div className='card-body'>
      {notifications.length > 0 ? (
        <ul className='list-none space-y-4'>
          {notifications?.map((notification: Notification) => (
            <li key={notification.id}>
              <div className='relative bg-white text-black rounded-2xl border border-[#00a089] p-4 shadow-md'>
                <div
                  className='cursor-pointer'
                  // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-call
                  onClick={() => onClickNotification(notification)}
                >
                  <div className='flex justify-between text-xs'>
                    <span className='font-bold'>
                      {notification?.details?.header}
                    </span>
                    <span>
                      {notification?.updated_at
                        ? `${formatDate(notification?.updated_at)}`
                        : `${formatDate(notification?.created_at as Date)}`}
                    </span>
                  </div>
                  <span className='text-xs mt-1'>
                    {notification?.details?.message}
                  </span>

                  <span className='text-xs mt-1'>
                    {notification?.details?.footer
                      ? ` (${notification?.details?.footer})`
                      : ''}{' '}
                  </span>
                </div>
                <Button
                  size='sm'
                  shape='circle'
                  className={`absolute -top-3 -right-3 w-6 h-6 p-0 !rounded-full bg-white text-[#00a089]
                   font-bold border border-[#00a089] flex items-center justify-center leading-none hover:bg-[#00a089]
                    hover:text-white transition`}
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    dismissNotification(Number(notification?.id))
                      .then(() => {})
                      .catch(() => {
                        console.error('Error dismissing notification');
                      });
                  }}
                  aria-label='dismiss-notification'
                >
                  ✕
                </Button>
              </div>
            </li>
          ))}
        </ul>
      ) : (
        <div className='card-body text-center text-gray-500'>
          No new notifications available
        </div>
      )}
    </div>
  );
}

export default Notifications;
